import type { GigyaGetAccountInfo } from '@ciam/gigya-api';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type UserInfo = {
  email: string;
  uid: string;
  uidSignature: string;
  signatureTimestamp: string;
  isAdLogin: boolean;
} & GigyaGetAccountInfo;

type State = {
  userInfo: UserInfo;
};

type Action = {
  setUserInfo: (userInfo: UserInfo) => void;
  clearLoginInfo: () => void;
};

export type LoginInfoStore = State & Action;

const STORAGE_KEY = 'login-info-store';

export const useLoginInfoStore = create<LoginInfoStore>()(
  persist(
    (set) => {
      const initialState: State = {
        userInfo: {
          email: '',
          uid: '',
          uidSignature: '',
          signatureTimestamp: '',
          isAdLogin: false,
        },
      };

      return {
        ...initialState,

        setUserInfo: (userInfo) => set({ userInfo }),
        clearLoginInfo: () => sessionStorage.removeItem(STORAGE_KEY),
      };
    },
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const clearLoginInfo = () => useLoginInfoStore.getState().clearLoginInfo();
